export const STAGE_LABELS = {
  idea: "Idea", research: "Research", script: "Script", storyboard: "Storyboard",
  assets_voice: "Assets & Voice", render: "Render", review: "Review",
  approved: "Approved", scheduled: "Scheduled",
};

export const STATUS_COLORS = {
  waiting: "bg-slate-700/50 text-slate-300 border-slate-600/50",
  running: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  failed: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  cancelled: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  blocked: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export function StageBadge({ stage }) {
  return (
    <span className="text-xs px-2 py-0.5 rounded-full bg-violet-500/10 text-violet-300 border border-violet-500/30">
      {STAGE_LABELS[stage] || stage}
    </span>
  );
}

export function StatusBadge({ status }) {
  return (
    <span className={`text-xs px-2 py-0.5 rounded-full border ${STATUS_COLORS[status] || STATUS_COLORS.waiting}`}>
      {status}
    </span>
  );
}

export function nextAction(p) {
  switch (p.stage) {
    case "idea": return "Write or generate a script";
    case "script": return "Generate a storyboard";
    case "storyboard": return "Add assets, narration & render";
    case "assets_voice": return "Render the video";
    case "render": return p.stage_status === "failed" ? "Retry render" : "Rendering…";
    case "review": return "Review & approve";
    case "approved": return "Mark ready for scheduling";
    case "scheduled": return "Awaiting Phase 4 publishing";
    default: return "Open project";
  }
}
